import React from 'react'
import { PageHeader, Space } from 'antd'
import styled from '@emotion/styled'

interface PageTooltipTypes {
  title?: string
  children: React.ReactChild | React.ReactChild[]
}

export const PageTooltip = (props: PageTooltipTypes) => (
  <Container>
    {props.title && (
      <PageHeader title={props.title} className='tooltip-title' />
    )}
    <Space className='tooltip-link' direction='vertical' align='start'>
      {props.children}
    </Space>
  </Container>
)

const Container = styled.div`
  background-color: #fafafb;
  padding: 16px 24px;
  border-radius: 8px;
`
